import {Component, OnInit} from '@angular/core';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {Observable} from 'rxjs';
import {currentUserContributorTransactionsDetails, ITabTransactionsDetails} from '@app/4dm1n/users-list/store/users-list.selector';
import {fuseAnimations} from '@fuse/animations';
import {Column} from 'devextreme/ui/data_grid';
import {TangoCardsService} from '@app/4dm1n/tango-cards/_store/tango-cards.service';
import {confirm} from 'devextreme/ui/dialog';

@Component({
  selector: 'app-transactions-tab',
  templateUrl: './transactions-tab.component.html',
  styleUrls: ['./transactions-tab.component.scss'],
  animations: fuseAnimations

})
export class TransactionsTabComponent extends OnDestroyMixin implements OnInit {

  cTransations$: Observable<ITabTransactionsDetails> = this.store.select(currentUserContributorTransactionsDetails).pipe(untilComponentDestroyed(this));

  /*

      {
      "transactionId": 141957,
      "organizationId": 146,
      "organizationName": "Inbe",
      "projectId": 109,
      "projectTitle": "Foodies",
      "surveyId": null,
      "surveyTitle": null,
      "amount": -37.48,
      "currency": "Credits",
      "description": "Amazon.ca - CAD50 - CAD50 - valeur points Inbe 37.48",
      "created": "2022-11-24T14:22:58.000Z",
      "type": "tango"
      "confirmationToken"
    }

   */

  columns: Column[] = [];

  constructor(
    private store: Store<AppState>,
    public tangoCardsService: TangoCardsService,
  ) {
    super();
  }

  ngOnInit(): void {

    this.columns = [
      {
        dataField: 'created',
        dataType: 'datetime',
        sortIndex: 1,
        sortOrder: 'desc',
      },
      {
        dataField: 'amount',
        dataType: 'number',
        format: 'currency',
      },
      {
        dataField: 'currency',
      },
      {
        dataField: 'projectTitle',
      },
      {
        dataField: 'surveyId',
      },
      {
        dataField: 'surveyTitle',
      },
      {
        dataField: 'type',
      },
      {
        dataField: 'confirmationToken',
        caption: 'confirmationToken',
        cellTemplate: 'referenceOrderIDTemplate',
      },
      {
        dataField: 'description',
      },

    ];

  }

  resendOrder(referenceOrderID: string) {

    console.log(referenceOrderID);
    return confirm(
      `Resend tangocard for reference ${referenceOrderID} ?`,
      'Resend tango Card'
    )
      .then((dialogResult) => {
          if (dialogResult) {
            this.tangoCardsService.resendCard(referenceOrderID);
          }
        }
      );

  }


}
